import { AnyAction, Store, ThunkDispatch, configureStore } from '@reduxjs/toolkit';
import profileReducer from './slices/profileSlice';
import appReducer from './slices/appSlice';
import buildReducer from './slices/buildSlice';
import brandingReducer from './slices/brandingSlice';
import notificationReducer from './slices/notificationsSlice';
import localisationReducer from './slices/localisationSlice';
import orgReducer from './slices/orgSlice';
import recoveryReducer from './slices/recoverySlice';
import contentReducer from './slices/contentSlice';
import socialReducer from './slices/socialSlice';
import onboardingReducer from './slices/onboardingSlice'
import userNotificationReducer from './slices/userNotificationsSlice';
import plannerReducer from './slices/plannerSlice'
import authReducer from './slices/authSlice'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import searchReducer from './slices/searchSlice';

export const store = configureStore({
  reducer: {
    app: appReducer,
    profile: profileReducer,
    build: buildReducer,
    branding: brandingReducer,
    notifications: notificationReducer,
    localisation: localisationReducer,
    org:orgReducer,
    recovery:recoveryReducer,
    onboarding: onboardingReducer,
    content:contentReducer,
    social:socialReducer,
    userNotifications: userNotificationReducer,
    planner: plannerReducer,
    search: searchReducer,
    auth: authReducer
  }
})
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppThunkDispatch = ThunkDispatch<RootState, any, AnyAction>;
export type AppStore = Omit<Store<RootState, AnyAction>, "dispatch"> & {
  dispatch: AppThunkDispatch;
};

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppThunkDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;